import { render, staticRenderFns } from "./DisconnectPopup.vue?vue&type=template&id=022cf31a&scoped=true&"
import script from "./DisconnectPopup.vue?vue&type=script&lang=js&"
export * from "./DisconnectPopup.vue?vue&type=script&lang=js&"
import style0 from "./DisconnectPopup.vue?vue&type=style&index=0&id=022cf31a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022cf31a",
  null
  
)

export default component.exports